import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SignUp from "./partials/SignUp";
import Chat from "./page/Chat";
import Profile from "./page/Profile";
import CV from "./page/CV";
import ProtectedRoute from "./components/ProtectedRoute";
import NameCollectionWrapper from "./components/NameCollectionWrapper";
import { Layout } from "./components/Layout";
import NotFound from "./components/NotFound";
import Cookies from "js-cookie";
import { ConversationsProvider } from "./context/ConversationsContext";
import { ProfileProvider } from "./context/ProfileContext";
import {
  isTelegramWebApp,
} from "./utils/telegramDetect";
import { installAichatbotTokenInterceptor } from "./utils/tokenRefresh";

installAichatbotTokenInterceptor();

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!Cookies.get("chatToken"));
  const [authChecked, setAuthChecked] = useState(false);

  // CRITICAL: For Telegram Mini App, validate token before trusting it
  useEffect(() => {
    const validateAuth = async () => {
      const token = Cookies.get("chatToken");

      // Sliding expiration: renew cookie for another 30 days on each visit
      if (token) {
        Cookies.set("chatToken", token, { expires: 30 });
      }

      // If in Telegram Mini App and has token, validate it
      if (isTelegramWebApp() && token) {
        try {
          const response = await fetch("https://api.oneplace.hr/v1/chat/profile/me", {
            headers: { Authorization: `Bearer ${token}` }
          });
          const data = await response.json();

          // If profile not found or no candidate data, token is invalid
          if (!data.found || !data.candidate || !data.candidate.id) {
            console.log("[App] Invalid token detected, clearing session");
            Cookies.remove("chatToken");
            localStorage.clear();
            setIsAuthenticated(false);
          }
        } catch (err) {
          console.error("[App] Token validation error:", err);
          // On error, clear token to be safe
          Cookies.remove("chatToken");
          localStorage.clear();
          setIsAuthenticated(false);
        }
      }
      setAuthChecked(true);
    };

    validateAuth();
  }, []);

  // Show loading while validating auth in Telegram Mini App
  if (isTelegramWebApp() && !authChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin border-4 border-t-4 rounded-full border-gray-300 border-t-blue-600 w-12 h-12 mx-auto mb-4"></div>
          <p className="text-gray-500">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      {/* Debug banner - comment out in production */}
      {/* <DebugBanner /> */}
      <ProfileProvider>
        <ConversationsProvider>
          <Routes>
            <Route path="/login" element={<SignUp />} />
            <Route
              path="/"
              element={
                isAuthenticated ? (
                  <Navigate to="/chat" replace />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />

            {/* Profile route */}
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />

            {/* CV route */}
            <Route
              path="/cv"
              element={
                <ProtectedRoute>
                  <CV />
                </ProtectedRoute>
              }
            />

            {/* Redirect from "/chat" to "/chat/{cId}/{jId}" */}
            <Route
              path="/chat"
              element={
                <ProtectedRoute>
                  <NameCollectionWrapper>
                    <Layout>
                      <Chat />
                    </Layout>
                  </NameCollectionWrapper>
                </ProtectedRoute>
              }
            />

            {/* Main chat route with cId and jId */}
            <Route
              path="/chat/:cId/:jId"
              element={
                <ProtectedRoute>
                  <NameCollectionWrapper>
                    <Layout>
                      <Chat />
                    </Layout>
                  </NameCollectionWrapper>
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<NotFound />} />

          </Routes>
        </ConversationsProvider>
      </ProfileProvider>
    </Router>
  );
}

export default App;
